import React from "react"

import New from "./New"
import Table from "./Table"

const ForeignLanguages = () => {
  return (
    <>
      <New />
      <Table />
    </>
  )
}

export default ForeignLanguages
